export const COACH_PROFILE_SIGN_UP_COPY = {
  name: '',
  title: '',
  testimonial: "Let's do this!",
}
